<template>
  <div>
    <v-row class="service-main-wrapper">
      <!-- Start Single Contact Card  -->
      <v-col
        lg="4"
        md="6"
        sm="6"
        cols="12"
        v-for="(address, i) in addressContent"
        :key="i"
      >
        <div class="text-left service service__style--2 bg_color--1">
          <div class="service">
            <div class="icon" v-html="iconSvg(address.icon)"></div>
            <div class="content">
              <h3 class="heading-title">{{ address.title }}</h3>
              <p v-if="address.title === 'Telefone'" class="phone-with-whatsapp">
                <span class="whatsapp-icon-small" v-html="whatsappIcon"></span>
                <a :href="address.to1">{{ address.info1 }}</a>
              </p>
              <p v-else>
                <a :href="address.to1">{{ address.info1 }}</a>
              </p>
              <p v-if="address.info2 && address.info2 !== '\u200B'">
                <a :href="address.to2">{{ address.info2 }}</a>
              </p>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    
    <!-- Google Maps Embed -->
    <div class="google-map rn-contact-map-area position-relative mt--40">
      <div class="mapouter">
        <div class="gmap_canvas">
          <iframe
            id="gmap_canvas_contact"
            src="https://maps.google.com/maps?q=Rua+José+Luiz+Marcelino,+62+-+Murta,+Itajaí+-+SC&t=&z=15&ie=UTF8&iwloc=&output=embed"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            loading="lazy"
            allowfullscreen=""
            referrerpolicy="no-referrer-when-downgrade"
            class="grayscale"
            title="Localização Codetime - Rua José Luiz Marcelino, 62 - Murta, Itajaí/SC"
          ></iframe>
        </div>
      </div>
    </div>
    
    <div
      class="text-left call-to-cation-tbn text-center"
      style="margin-top: 50px;"
    >
      <a :href="whatsLink" class="cta-whatsapp footer-cta-whatsapp contact-address-whatsapp-btn" target="_blank" rel="noopener">
        <i class="mdi mdi-whatsapp"></i>
        <span class="cta-text">Falar no WhatsApp</span>
      </a>
    </div>
  </div>
</template>

<script>
  import feather from "feather-icons";
  export default {
    data() {
      return {
        whatsappIcon: `<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.372a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>`,
        addressContent: [
          {
            icon: "phone",
            title: "Telefone",
            info1: "(47) 93380-7051",
            info2: "\u200B", // Caractere invisível
            to1: "https://wa.me/5547933807051?text=Olá, vim pelo site e gostaria de falar sobre um projeto.",
            to2: "#",
          },
          {
            icon: "mail",
            title: "E-mail",
            info1: "contato@codetime.com.br",
            info2: "\u200B", // Caractere invisível
            to1: "mailto:contato@codetime.com.br",
            to2: "#",
          },
          {
            icon: "map-pin",
            title: "Localização",
            info1: "Rua José Luiz Marcelino, 62 - Murta, Itajaí/SC",
            to1: "https://maps.app.goo.gl/c9fW8Q9jdct8iYG56",
            info2: "\u200B",
            to2: "#",
          },
        ],
        whatsLink: "https://wa.me/5547933807051",
      };
    },
    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>

<style lang="scss">
  /* Estilos específicos para os cards de contato seguindo o padrão dos serviços */
  .service-main-wrapper .service.service__style--2 {
    /* Mantém o texto em branco como era antes */
    .content h3.heading-title {
      color: #ffffff !important;
    }
    
    .content p {
      color: rgba(255, 255, 255, 0.8) !important;
      margin-bottom: 8px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
    
    /* Garante que os links tenham cor apropriada */
    .content p a {
      color: rgba(255, 255, 255, 0.8) !important;
      text-decoration: none;
      transition: color 0.3s ease;
      
      &:hover {
        color: var(--color-primary);
      }
    }
  }

  /* Classe específica para o botão do WhatsApp no componente ContactAddress */
  .contact-address-whatsapp-btn {
    /* Mantém o estilo visual original, apenas aumenta o tamanho */
    font-size: 1.3em !important;
    padding: 18px 35px !important; /* Aumentado o espaçamento */
    margin: 20px 0 !important; /* Adiciona margem vertical */
    
    .mdi {
      font-size: 1.3em !important;
      margin-right: 10px !important; /* Espaçamento entre ícone e texto */
    }
    
    .footer-cta-whatsapp {
      height: 45px !important;
    }
    .cta-text {
      font-size: 1.3em !important;
    }
  }
  
  /* Ajustes para mobile */
  @media (max-width: 959px) {
    .contact-address-whatsapp-btn .cta-text {
      font-size: 1.1em !important;
    }
  }
  
  /* Estilos para telefone com ícone WhatsApp */
  .phone-with-whatsapp {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .whatsapp-icon-small {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    opacity: 0.9;
  }
  
  .whatsapp-icon-small svg {
    width: 16px;
    height: 16px;
  }
  
  /* Estilos para o mapa do Google - mesmo estilo dos cards */
  .mapouter {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 14px;
    overflow: hidden;
  }
  
  .gmap_canvas {
    overflow: hidden;
    background: none !important;
    height: 400px;
    width: 100%;
    border-radius: 14px;
    @media only screen and (max-width: 1199px) {
      height: 300px;
    }
    @media only screen and (max-width: 992px) {
      height: 250px;
    }
  }
  
  .gmap_canvas iframe {
    width: 100%;
    height: 100%;
    border-radius: 14px;
    filter: grayscale(100%) brightness(0.85) contrast(1.1);
    transition: filter 0.3s ease;
  }
  
  .gmap_canvas iframe:hover {
    filter: grayscale(80%) brightness(0.9) contrast(1.05);
  }
</style>
